 /* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import clsx from "clsx";
import theme from "../../../../Themes/defaultTheme";

const useStyles = makeStyles((appTheme) => ({
  formControlLabel: {
    display: "inline-flex",
    alignItems: "center",
    "&.Mui-disabled": {
      cursor: "not-allowed !important",
      "& .MuiFormControlLabel-label": {
        color: "var(--color-text-secondary) !important",
        opacity: 0.65,
        cursor: "not-allowed !important",
      },
      "& [class*='MuiSvgIcon-root']": {
        opacity: 0.65,
      },
    },
  },
  root: {
    "&.Mui-disabled, &$disabled": {
      cursor: "not-allowed !important",
      pointerEvents: "none",
    },
    "&$sizeSmall": {
      "& $switchBase": {
        padding: "4px !important",
        width: "auto !important",
        height: "auto !important",
        "&$checked": {
          transform: "translateX(16px)",
        },
      },
      "& $thumb": {
        width: 16,
        height: 16,
      },
    },
  },
  sizeSmall: {},
  switchBase: {
    padding: "9px !important",
    top: 0,
    left: 0,
    width: "auto !important",
    height: "auto !important",
    boxSizing: "border-box",
    "&$checked": {
      transform: "translateX(20px)",
    },
    "&$disabled": {
      cursor: "not-allowed !important",
      pointerEvents: "none",
      opacity: 0.6,
      "& $thumb": {
        boxShadow: "none !important",
        backgroundColor: "var(--total_row_boldbackground, #bdbdbd) !important",
        'html[data-mode="dark"] &': {
          backgroundColor: "#475569 !important",
        },
      },
      "& + $track": {
        backgroundColor: "rgba(0, 0, 0, 0.15) !important",
        opacity: "0.15 !important",
        'html[data-mode="dark"] &': {
          backgroundColor: "rgba(255, 255, 255, 0.15) !important",
          opacity: "0.15 !important",
        },
      },
    },
    "&$disabled&$checked": {
      "& $thumb": {
        backgroundColor:
          "color-mix(in srgb, var(--color-primary-main) 50%, var(--total_row_boldbackground, #bdbdbd)) !important",
        'html[data-mode="dark"] &': {
          backgroundColor:
            "color-mix(in srgb, var(--color-primary-main) 50%, #2d3748) !important",
        },
      },
      "& + $track": {
        backgroundColor: "var(--color-primary-main) !important",
        opacity: "0.25 !important",
      },
    },
  },
  colorPrimary: {
    "&$checked": {
      color: "var(--color-primary-main)",
      "& $thumb": {
        backgroundColor: "var(--color-primary-main)",
      },
      "& + $track": {
        backgroundColor: "var(--color-primary-main)",
        opacity: 0.5,
      },
    },
    "&$disabled&$checked": {
      "& $thumb": {
        backgroundColor:
          "color-mix(in srgb, var(--color-primary-main) 50%, var(--total_row_boldbackground, #bdbdbd)) !important",
        'html[data-mode="dark"] &': {
          backgroundColor:
            "color-mix(in srgb, var(--color-primary-main) 50%, #2d3748) !important",
        },
      },
      "& + $track": {
        backgroundColor: "var(--color-primary-main) !important",
        opacity: "0.25 !important",
      },
    },
  },
  colorSecondary: {
    "&$checked": {
      color: "var(--color-secondary-main)",
      "& $thumb": {
        backgroundColor: "var(--color-secondary-main)",
      },
      "& + $track": {
        backgroundColor: "var(--color-secondary-main)",
        opacity: 0.5,
      },
    },
    "&$disabled&$checked": {
      "& $thumb": {
        backgroundColor:
          "color-mix(in srgb, var(--color-secondary-main) 50%, var(--total_row_boldbackground, #bdbdbd)) !important",
        'html[data-mode="dark"] &': {
          backgroundColor:
            "color-mix(in srgb, var(--color-secondary-main) 50%, #2d3748) !important",
        },
      },
      "& + $track": {
        backgroundColor: "var(--color-secondary-main) !important",
        opacity: "0.25 !important",
      },
    },
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: appTheme.shadows[1],
    backgroundColor: "#ffffff",
    'html[data-mode="dark"] &': {
      backgroundColor: "#e2e8f0",
    },
  },
  track: {
    'html[data-mode="dark"] &': {
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      opacity: 0.3,
    },
  },
  checked: {},
  disabled: {},
}));

const A_Switch = (props) => {
  const classes = useStyles();
  const {
    color,
    checked,
    size,
    disabled,
    name,
    ariaLabel,
    onChange,
    onClick,
    label,
    labelPlacement,
    className,
    style,
    inputProps,
    switchClasses,
    ...rest
  } = props;

  return (
    <ThemeProvider theme={theme}>
      <FormControlLabel
        className={clsx(classes.formControlLabel, className)}
        style={style}
        disabled={disabled}
        control={
          <Switch
            classes={{
              root: classes.root,
              sizeSmall: classes.sizeSmall,
              switchBase: classes.switchBase,
              thumb: classes.thumb,
              track: classes.track,
              checked: classes.checked,
              disabled: classes.disabled,
              colorPrimary: classes.colorPrimary,
              colorSecondary: classes.colorSecondary,
              ...switchClasses,
            }}
            color={color}
            checked={checked}
            size={size}
            disabled={disabled}
            name={name}
            inputProps={{ "aria-label": ariaLabel, ...inputProps }}
            onChange={onChange}
            onClick={onClick}
            {...rest}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
    </ThemeProvider>
  );
};

A_Switch.defaultProps = {
  checked: false,
  color: "primary",
  label: "Switch",
  labelPlacement: "start",
  disabled: false,
  size: "medium",
  name: "",
};

A_Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.oneOf(["medium", "small"]),
  disabled: PropTypes.bool,
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  label: PropTypes.node,
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default A_Switch;
